import { render, staticRenderFns } from "./MerchantTree.vue?vue&type=template&id=9a16907e&scoped=true"
import script from "./MerchantTree.vue?vue&type=script&lang=js"
export * from "./MerchantTree.vue?vue&type=script&lang=js"
import style0 from "./MerchantTree.vue?vue&type=style&index=0&id=9a16907e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a16907e",
  null
  
)

export default component.exports